import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const PasswordInstructionsContainer = styled.div`
  margin-bottom: 25px;
`

const PasswordInstructionsTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.075em;
  color: #000000;
  margin-bottom: 10px;
`

const PasswordInstructionsList = styled.ul`
  margin: 0;
  padding: 0 15px 0 0;
`

const PasswordInstructionItem = styled.li`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.075em;
  color: #757575;
`

const instructionOrder = ['first', 'second', 'third', 'forth']

const PasswordInstructions: React.FC = () => {
  const { t } = useTranslation('', {
    keyPrefix: 'pages.signUp.password.instructions',
  })

  return (
    <PasswordInstructionsContainer>
      <PasswordInstructionsTitle>{t('title')}</PasswordInstructionsTitle>
      <PasswordInstructionsList>
        {instructionOrder.map((key, index) => (
          <PasswordInstructionItem key={index}>
            {t(`rules.${key}`)}
          </PasswordInstructionItem>
        ))}
      </PasswordInstructionsList>
    </PasswordInstructionsContainer>
  )
}

export default PasswordInstructions
